var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.dataType == 'html')?_c('span',{domProps:{"innerHTML":_vm._s(_vm.displayValue)}}):_c('span',{staticClass:"ds-span"},[_vm._v(_vm._s(_vm.displayValue))])
}
var staticRenderFns = []

export { render, staticRenderFns }